import { GroupContract, InventoryStatistics, Product } from '../../roominglist/dtt/getEventSummaryById.types';
import { PropertyResponse } from '../addHotel.types';

export type AddHotelDttInput = {
  propertyId: string;
  imageLimitPerCategory: number;
  input?: GroupEventsAtPropertyInput;
};

export type GroupEventsAtPropertyInput = {
  propertyId: string;
  filters: {
    groupCode: string;
  };
  activeStatus: ActiveStatus;
  groupBlockCodeExactMatch: boolean;
  eventLookupDateRange: {
    startDate: string;
    endDate?: string;
  };
};

export type AddHotelDttResponse = {
  property: PropertyResponse;
  hotelOperations?: {
    groupManagement: {
      groupEventsAtProperty: {
        groupBlocks: {
          sourceCRS: SourceCRS;
          groupContract: GroupContract;
          products: Product[];
        }[];
      };
    };
  };
};

export enum SourceCRS {
  MARSHA = 'MARSHA',
  ACRS = 'ACRS',
  DSP = 'DSP',
}

export enum ActiveStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}

export type InventoryCheckDttResponse = {
  hotelOperations: {
    groupManagement: {
      groupEventsAtPropertyWithInventory: {
        inventoryStatistics: InventoryStatistics;
      };
    };
  };
};
